<template>
  <div id="hamburger-icon" :class="[{ open: toggled }]" @click="toggleIcon">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  name: "HamburgerMenu",
  props: {},
  components: {},
  data: () => ({
    toggled: false
  }),
  created() {},
  watch: {
    toggled() {
      this.$emit("input", this.toggled);
    }
  },
  methods: {
    toggleIcon() {
      this.toggled = !this.toggled;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#hamburger-icon span:nth-child(1) {
  top: 0px;
}

#hamburger-icon span:nth-child(2),
#hamburger-icon span:nth-child(3) {
  top: 8px;
}

#hamburger-icon span:nth-child(4) {
  top: 16px;
}

#hamburger-icon.open span:nth-child(1) {
  opacity: 0;
}

#hamburger-icon.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#hamburger-icon.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#hamburger-icon.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#hamburger-icon {
  width: 25px;
  height: 22px;
  position: relative;
  margin: auto;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

#hamburger-icon span {
  display: block;
  position: absolute;
  height: 4px;
  width: 100%;
  background: $color-primary;
  border-radius: 5px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}
</style>
